import { createReducer, on } from '@ngrx/store';
import { TreeNode } from 'primeng/api';
import { selectNode, toggleNode, loadDivisionsSuccess, refreshTree, setSelectedStock } from './InternalDivisionAction';

export interface InternalDivisionState {
    expandedKeys: { [key: string]: boolean };
    selectedKey?: string;
    divisions: TreeNode[];
    loading: boolean;
    selectedStockId: number | null;
}

export const initialInternalDivisionState: InternalDivisionState = {
    expandedKeys: {},
    selectedKey: undefined,
    divisions: [],
    loading: false,
    selectedStockId: null
};

export const InternalDivisionReducer = createReducer(
    initialInternalDivisionState,
    on(toggleNode, (state, { key, expanded }) => ({
        ...state,
        expandedKeys: { ...state.expandedKeys, [key]: expanded }
    })),
    on(selectNode, (state, { key }) => ({
        ...state,
        selectedKey: key
    })),
    on(loadDivisionsSuccess, (state, { divisions }) => ({
        ...state,
        divisions,
        loading: false
    })),
    on(refreshTree, (state) => ({
        ...state,
        loading: true
    })),
    on(setSelectedStock, (state, { stockId }) => ({
        ...state,
        selectedStockId: stockId,
        divisions: [],
        expandedKeys: {},
        selectedKey: undefined
    }))
);
